// extracted by mini-css-extract-plugin
module.exports = {"authors":"style__authors___3xZGF","meta":"style__meta___3fNP7"};